import React from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import PageHeaderComponent from '../../helpers/components/page_header.component';
import PurchaseOrderDetail from './components/order_detail';
import { useParams } from 'react-router-dom';

const PurchaseOrder = () => {
    const { id } = useParams();
    return (
        <>
            <ContainerComponent span={22} top={20} bottom={20}>
                <PageHeaderComponent is_back={true} />
                <PurchaseOrderDetail order_id={id} />
            </ContainerComponent>
        </>
    );
}

export default PurchaseOrder;